import { render, staticRenderFns } from "./Childcare.vue?vue&type=template&id=509b080c&scoped=true&"
import script from "./Childcare.vue?vue&type=script&lang=js&"
export * from "./Childcare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b080c",
  null
  
)

export default component.exports